/**
 * Волна E (docs/MIGRATION_ROUTER.md §5). Было: <PrivateRoute exact path='/signin'>.
 * Тот же MainPage — модалка входа поверх главной.
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../CacheDataRoute';
import Index from '@routes/MainPage';

export const Route = createFileRoute('/signin')({
  component: () => <CacheDataRoute component={Index} path='/signin' />
});
